import React from "react";
import { subMonths } from "date-fns";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MuiThemeProvider } from "@material-ui/core";
import UItheme from "@bamboobox/b2-theme";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useEffect } from "react";
import "./TimeSpanComponent.css";

function convertDateRangeToFormattedString(oldDate, currentDate, check) {
  let monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let dateString;
  if (check)
    dateString = `${oldDate.getDate()} ${monthArray[oldDate.getMonth()]}, ${oldDate.getFullYear().toString().substring(2, 4)} - ${currentDate.getDate()} ${
      monthArray[currentDate.getMonth()]
    }, ${currentDate.getFullYear().toString().substring(2, 4)}`;
  else {
    dateString = `${oldDate.getDate()} ${monthArray[oldDate.getMonth()]}, ${oldDate.getFullYear().toString().substring(2, 4)}`;
  }
  return dateString;
}

function  TimeSpanComponent(props) {
  let today = new Date();
  let threeMonthsOldDate = subMonths(today, 3);

  let frequencyValues = ["1 Day", "Week", "2 Weeks", "Month", "2 Months", "Quarter", "Year"];

  const [open, setOpen] = React.useState(false);

  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [oldDate, setOldDate] = React.useState(threeMonthsOldDate);
  const [displayedDate, setDisplayedDate] = React.useState(convertDateRangeToFormattedString(oldDate, currentDate, props.enableToRange));

  const [fromDateMax, setFromDateMax] = React.useState(new Date());
  const [fromDateMin, setFromDateMin] = React.useState(undefined);
  const [toDateMax, setToDateMax] = React.useState(new Date());
  const [toDateMin, setToDateMin] = React.useState(undefined);

  const [radioBtnValue, setRadioBtnValue] = React.useState("fixed");

  const [numberFieldvalue, setNumberFieldvalue] = React.useState("1");
  const [intervalValue, setIntervalValue] = React.useState("Month");
  const [prevOldDate, setPrevOldDate] = React.useState(oldDate);
  const [prevCurrentDate, setPrevCurrentDate] = React.useState(currentDate);
  const [prevIntervalValue, setPrevIntervalValue] = React.useState(intervalValue);
  const [prevNumberFieldValue, setPrevNumberFieldValue] = React.useState(numberFieldvalue);

  let setFromDate = props?.setFromDate;
  let setToDate = props?.setToDate;

  const handleNumberChange = (event) => {
    // console.log("changed number to ", event?.target?.value)

    let todayDate = new Date();
    setCurrentDate(new Date());

    if (event?.target?.value < 0) event.target.value = 0;

    if (intervalValue === "Day") {
      todayDate.setDate(todayDate.getDate() - parseInt(numberFieldvalue));
    }
    if (intervalValue === "Week") {
      todayDate.setDate(todayDate.getDate() - parseInt((event.target.value || 0) * 7));
    }
    if (intervalValue === "Month") {
      todayDate.setMonth(todayDate.getMonth() - parseInt(event.target.value || 0));
    }
    if (intervalValue === "Quarter") {
      todayDate.setMonth(todayDate.getMonth() - parseInt((event.target.value || 0) * 3));
    }
    if (intervalValue === "Year") {
      todayDate.setFullYear(todayDate.getFullYear() - parseInt(event.target.value || 0));
    }

    setOldDate(new Date(todayDate));

    if (numberFieldvalue !== event?.target?.value) {
      setPrevNumberFieldValue(numberFieldvalue);
      setNumberFieldvalue(event.target.value);
    }
  };

  const handleIntervalChange = (event) => {
    // console.log("changed interval to ", event?.target?.value)

    let todayDate = new Date();
    setCurrentDate(new Date());

    // if (event.target?.value === "Days") {
    //   todayDate.setDate(todayDate.getDate() - parseInt(numberFieldvalue));
    // } else 
    if (event.target?.value === "Week") {
      todayDate.setDate(todayDate.getDate() - parseInt((numberFieldvalue || 0) * 7));
    } else if (event.target?.value === "Month") {
      todayDate.setMonth(todayDate.getMonth() - parseInt(numberFieldvalue || 0));
    } else if (event.target?.value === "2 Weeks") {
      todayDate.setDate(todayDate.getDate() - 14);
    } else if (event.target?.value === "1 Day") {
      todayDate.setDate(todayDate.getDate() - 1);
    } else if (event.target?.value === "2 Months") {
      todayDate.setMonth(todayDate.getMonth() - 2);
    } else if (event.target?.value === "Quarter") {
      todayDate.setMonth(todayDate.getMonth() - parseInt((numberFieldvalue || 0) * 3));
    } else if (event.target?.value === "Year") {
      todayDate.setFullYear(todayDate.getFullYear() - parseInt(numberFieldvalue || 0));
    }

    setOldDate(new Date(todayDate));


    if (intervalValue !== event?.target?.value) {
      setPrevIntervalValue(intervalValue);
      setIntervalValue(event.target.value);
    }
  };

  const handleRadioBtnChange = (event) => {
    setRadioBtnValue(event?.target?.value);
    let e = { target: { value: "" } };
    e.target.value = intervalValue;
    handleIntervalChange(e);
  };

  const handleNormalBtnClick = () => {
    if (open) {
      setOldDate(prevOldDate);
      setCurrentDate(prevCurrentDate);
      setNumberFieldvalue(prevNumberFieldValue);
      setIntervalValue(prevIntervalValue);
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const handleDateFromChange = (value) => {
    let tempDate = new Date(value);
    setToDateMin(tempDate.setDate(tempDate.getDate() + 1));
    setPrevOldDate(oldDate);
    setOldDate(new Date(value));
    console.log("handleDateFromChange ", value, new Date(value), tempDate, toDateMin);
  };

  const handleDateToChange = (value) => {
    let tempDate = new Date(value);

    setFromDateMax(tempDate.setDate(tempDate.getDate() - 1));
    setPrevCurrentDate(currentDate);
    setCurrentDate(new Date(value));
    console.log("handleDateToChange ", value, new Date(value), tempDate, fromDateMin);
  };

  useEffect(() => {
    handleClickAway();
  }, [props.input]);

  const handleClickAway = () => {
    props.setIsLoading(true);
    console.log("handleClickAway", convertDateRangeToFormattedString(oldDate, currentDate, props.enableToRange));
    setOpen(false);

    setDisplayedDate(convertDateRangeToFormattedString(oldDate, currentDate, props.enableToRange));
    var fromDateValue = new Date(Date.UTC(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate()));
    // fromDateValue.setUTCDate(fromDateValue.getDate())
    // fromDateValue.setUTCHours(0, 0, 0, 0)

    var toDateValue = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    // toDateValue.setUTCDate(toDateValue.getDate())
    // toDateValue.setUTCHours(0, 0, 0, 0)
    if (props.fromDate?.toISOString().substring(0, 10) !== fromDateValue?.toISOString().substring(0, 10))
      // so that same date is not updated again
      setFromDate(fromDateValue);
    if (props.toDate?.toISOString().substring(0, 10) !== toDateValue?.toISOString().substring(0, 10))
      // so that same date is not updated again
      setToDate(toDateValue);

    props.setIsLoading(false);
  };

  const handleCancelBtn = () => {
    setOpen(false);
    setOldDate(prevOldDate);
    setCurrentDate(prevCurrentDate);
    setNumberFieldvalue(prevNumberFieldValue);
    setIntervalValue(prevIntervalValue);
  };

  return (
    <MuiThemeProvider theme={UItheme}>
      <ClickAwayListener onClickAway={() => {}}>
        <span className="dropdownLayout">
          <Button
            variant="outlined"
            onClick={handleNormalBtnClick}
            style={{ color: "rgba(61, 61, 59, 1)", borderRadius: "6px", borderColor: "#D2D2D2", height: "28px", fontSize: "12px", textTransform: "none" }}
            size="medium"
          >
            <span style={{ marginRight: "14px" }}>{displayedDate}</span>
            <KeyboardArrowDownRoundedIcon style={{ position: "absolute", right: "2%" }} />
          </Button>

          {open ? (
            <Paper className="act_like_dropdown">
              <RadioGroup value={radioBtnValue} onChange={handleRadioBtnChange}>
                <FormControlLabel
                  value="fixed"
                  control={<Radio style={{ color: "#016B40" }} />}
                  label={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "4px",
                        gap: "10px",
                      }}
                    >
                      Past
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                          pattern: "[0-9]*",
                        }}
                        type="number"
                        onChange={handleNumberChange}
                        disabled={radioBtnValue !== "fixed"}
                        value={numberFieldvalue}
                        style={{ marginLeft: "10px", width: "35px" }}
                      />
                      <Select value={intervalValue} renderValue={(value) => <label>{value}</label>} onChange={handleIntervalChange} disabled={radioBtnValue !== "fixed"} >
                        {frequencyValues.map((data, index) => {
                          return (
                            <MenuItem key={index} value={data}>
                              {data}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      Ago
                    </div>
                  }
                />

                <FormControlLabel
                  value="custom"
                  style={{
                    alignItems: "flex-start",
                    paddingTop: "20px",
                  }}
                  control={<Radio style={{ color: "#016B40", marginBottom: "10px" }} />}
                  label={
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "8px",
                        flexDirection: "column",
                      }}
                    >
                      <Typography style={{ fontSize: "16px", fontWeight: 400 }} variant="subtitle1" gutterBottom>
                        Custom Date
                      </Typography>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        From:
                        <KeyboardDatePicker
                          disableToolbar
                          disabled={radioBtnValue === "fixed"}
                          minDate={fromDateMin}
                          maxDate={fromDateMax}
                          variant="inline"
                          format="dd-MM-yyyy"
                          margin="none"
                          label="DD-MM-YYYY"
                          value={oldDate}
                          onChange={handleDateFromChange}
                          autoOk={true}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                        {props.enableToRange && (
                          <>
                            <br />
                            To:
                            <KeyboardDatePicker
                              disableToolbar
                              disabled={radioBtnValue === "fixed"}
                              minDate={toDateMin}
                              maxDate={toDateMax}
                              variant="inline"
                              format="dd-MM-yyyy"
                              margin="none"
                              label="DD-MM-YYYY"
                              value={currentDate}
                              onChange={handleDateToChange}
                              autoOk={true}
                              KeyboardButtonProps={{
                                "aria-label": "change date",
                              }}
                            />
                          </>
                        )}
                      </MuiPickersUtilsProvider>
                    </div>
                  }
                />
              </RadioGroup>
              <div style={{ display: "flex", marginTop: "15px", alignContent: "center", justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  sx={{ borderRadius: "12px", border: "1px solid #DFE2DE", color: "#3D3D3B", fontWeight: 600, "&:hover": { borderColor: "#3D3D3B" } }}
                  onClick={handleCancelBtn}
                  style={{ height: '37px', color: '#424242', textTransform: 'none', padding: '10px', fontSize: '14px', cursor:'pointer', fontWeight: '500', border: '1px solid #e0e0e0', borderRadius: '6px', width: '79px', marginRight: '16px' }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  style={{ height: '37px', backgroundColor: "#016B40", borderRadius: "6px", textTransform: "none", fontWeight: 600, fontSize: "12px", "&:hover": { backgroundColor: "#016B40" } }}
                  onClick={handleClickAway}
                >
                  Apply
                </Button>
              </div>
            </Paper>
          ) : null}
        </span>
      </ClickAwayListener>
    </MuiThemeProvider>
  );
}

export default TimeSpanComponent;
